"use client"

import Text from "@/components/common/Typography/Text"
import ClockIcon from "@/components/icons/ClockIcon"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useAppSelector } from "@/lib/redux/hooks"
import { getEsimOrderCode, isValidEsimOrderCode } from "@/utils/esim/esimBooking"
import { Col, Row } from "antd"
import { useEffect, useMemo, useRef, useState } from "react"
import ModalTimeOut, { ModalTimeOutRef } from "./ModalTimeOut"
import dayjs from "dayjs"

import { usePathname, useSearchParams } from "next/navigation"
import { useTranslation } from "react-i18next"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { consumeSkyscannerTimeoutBypass } from "@/utils/booking/dayviewAttribution"
import { FLIGHT_CHECKOUT_SECONDS } from "@/utils/booking/getPaymentDeadline"

export let intevalBookingTimer: any

const BookingTimmer = () => {
  const { t } = useTranslation()
  const showModalTimeout = useAppSelector(state => state.booking.showModalTimeOut)
  const step_booking = useAppSelector(state => state.booking.step_booking)
  const isDesktop = useIsDesktop()
  const refModalTimeOut = useRef<ModalTimeOutRef>(null)
  const [timer, setTimer] = useState(900)
  const pathname = usePathname()
  const searchParams = useSearchParams()
  // Flight payment step: the checkout page, or the repayment page of an existing order.
  const isCheckoutFlight = pathname.includes('/booking/flight/checkout') || pathname.includes('/booking/repayment')
  const isBookingEsim = pathname.includes('/booking/esim')
  const esimBookingDraft = useAppSelector((state) => state.esim.bookingDraft)
  const esimOrderCode = getEsimOrderCode(esimBookingDraft?.order)
  const hasEsimOrder = isBookingEsim && isValidEsimOrderCode(esimOrderCode)

  const initTimmer = useMemo(() => isCheckoutFlight ? FLIGHT_CHECKOUT_SECONDS : 900, [isCheckoutFlight])
  const { getValidDayjs } = useTETranslation()

  useEffect(() => {
    if (intevalBookingTimer) {
      clearInterval(intevalBookingTimer)
    }
    if (isBookingEsim && !hasEsimOrder) {
      setTimer(initTimmer)
      return
    }
    if (showModalTimeout) {
      setTimer(0)
      return;
    }
    intevalBookingTimer = setInterval(() => {
      const now = dayjs()
      setTimer(() => {
        const oldTimeSession = getValidDayjs(localStorage.getItem('current_time_session'))

        const nextValue = initTimmer - now.diff(oldTimeSession, 'second')
        if (nextValue <= 0) {
          if (consumeSkyscannerTimeoutBypass('booking', searchParams)) {
            // Temporary hotfix: stale current_time_session from a previous visit false-fires
            // this popup right when a NEW Skyscanner redirect lands — treat it as a fresh
            // session instead. Only bypasses once per redirect id: a real expiry later in this
            // same redirect's session still shows the popup like any other visitor.
            localStorage.setItem('current_time_session', dayjs().toString())
            return initTimmer
          }
          refModalTimeOut.current?.open()
          clearInterval(intevalBookingTimer)
          return 0
        }

        return nextValue
      })
    }, 1000)

    return () => {
      if (intevalBookingTimer) {
        clearInterval(intevalBookingTimer)
      }
    }
  }, [initTimmer, showModalTimeout, isBookingEsim, hasEsimOrder])

  useEffect(() => {
    return () => {
      if (intevalBookingTimer) {
        clearInterval(intevalBookingTimer)
      }
    }
  }, [])

  const minutes = Math.floor(timer / 60)
  const seconds = timer % 60

  if (isBookingEsim && !hasEsimOrder) {
    return null
  }

  return (
    <Row wrap={false} justify='center' align='middle' className={`layout-booking__header--bottom${isDesktop ? '' : ' layout-booking__header--bottom-mobile'}`}>
      <ModalTimeOut ref={refModalTimeOut} />
      <Col>
        <ClockIcon className="layout-booking__header--bottom-clock" />
      </Col>
      <Col style={{ lineHeight: 1, minWidth: 0 }}>
        <Text style={{ textAlign: "center", lineHeight: 1, whiteSpace: "nowrap" }}>
          {t("booking.timmer_title")} <Text strong className="layout-booking__header--bottom-timmer">{minutes < 10 ? `${0}${minutes}` : minutes}:{seconds < 10 ? `${0}${seconds}` : seconds}</Text>
        </Text>
      </Col>

    </Row>
  )
}

export default BookingTimmer